export default __webpack_public_path__ + "static/media/partner3.ac46c3b8.svg";